import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { AuthProvider } from "contexts/auth/auth.context";
import { ToastProvider } from "./contexts/toast/toast.context";
import { CalendarConfigProvider } from "./contexts/calendar/calendar.context";
import { ConfirmModalProvider } from "./contexts/confirmModal/confirmModal.context";
import { Provider } from 'react-redux';
import { QueryClient, QueryClientConfig } from "@tanstack/query-core";
import { QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./AppRoutes";
import AxiosInterceptor from "./components/AxiosInterceptor/AxiosInterceptor";
import theme from "theme/theme";
import store from "./store/store";
import "./app.scss";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
} as QueryClientConfig);

const App = () => {
  return (
    <Provider store={store}>
      <ConfigProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <CalendarConfigProvider>
            <ConfirmModalProvider>
              <ToastProvider>
                <BrowserRouter
                  future={{v7_startTransition: true, v7_relativeSplatPath: true}}
                >
                  <AppRoutes />
                  <AxiosInterceptor />
                </BrowserRouter>
              </ToastProvider>
            </ConfirmModalProvider>
          </CalendarConfigProvider>
        </AuthProvider>
        </QueryClientProvider>
      </ConfigProvider>
    </Provider>
  );
};
export default App;
